import classNames from 'classnames';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { withGw2Theme } from '../utils/withGw2Theme';

const useStyles = makeStyles()((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  title: {
    color: '#fff',
    position: 'relative',
    width: `calc(100% - ${theme.spacing(2)})`,
    marginLeft: 'auto',
    marginRight: 'auto',
    backgroundColor: theme.palette.primary.dark,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.divider}`,
    lineHeight: '1.2 !important',
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${theme.spacing(4)})`,
    },
    fontWeight: 500,
    fontSize: '1.4258rem',
    zIndex: 10,
  },
  content: {
    boxShadow: `${theme.shadows[2].replace(/\),/g, ') inset,')} inset`,
    backgroundColor: theme.palette.embossed,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    '& > *:last-child': {
      marginBottom: 0,
    },
  },
  contentWithTitle: {
    position: 'relative',
    top: -23,
    paddingTop: theme.spacing(5),
    marginTop: -theme.spacing(1) * 3,
  },
  tabsTitle: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    padding: 0,
    overflow: 'hidden',
  },
  tabDown: { '& > p:last-child': { marginBottom: 0 } },
  noPadding: { padding: '0 !important' },
}));

interface EmbossedCardProps {
  title?: string;
  className?: string;
  children?: React.ReactNode;
  isTabs?: boolean;
  specialization?: string;
}

function EmbossedCard({
  className,
  isTabs,
  title,
  specialization,
  children,
}: EmbossedCardProps) {
  const { classes } = useStyles();

  return (
    <div className={classNames(classes.root, className)}>
      {(title || specialization) && (
        <div
          className={classNames(classes.title, {
            [classes.tabsTitle]: !!isTabs,
          })}
        >
          {title || specialization}
        </div>
      )}

      <div
        className={classNames(classes.content, {
          [classes.contentWithTitle]: !!title || !!specialization,
          [classes.tabDown]: !!isTabs,
        })}
      >
        {children}
      </div>
    </div>
  );
}

export default withGw2Theme()(EmbossedCard);
